<template>
    <div>
        <b-row v-if="formData">
            <b-col cols="12" md="6">
                <b-form-group :label="$t('coop_cv_name')">
                    <div class="label-as-input">{{ formData.name || '-' }}</div>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('coop_cv_file')">
                    <div class="label-as-input">
                        <a href="#" @click.prevent="downloadFile" class="text-primary font-weight-bold">
                            <i class="ri-download-line mr-1"></i> {{ displayFileName }}
                        </a>
                    </div>
                </b-form-group>
            </b-col>
            <b-col cols="12">
                <b-form-group :label="$t('label')">
                    <div class="label-as-input">
                        <b-badge variant="secondary">
                            {{ tagLabel }}
                        </b-badge>
                    </div>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import CoopCvService from '@/services/CoopCvService';
    import ParameterItemService from '@/services/ParameterItemService';

    export default {
        props: {
            formId: {
                type: [Number, String],
                required: true
            }
        },
        data() {
            return {
                formData: null,
                tagOptions: [
                    { value: 'tr', text: 'Türkçe' },
                    { value: 'en', text: 'İngilizce' },
                    { value: 'de', text: 'Almanca' },
                    { value: 'fr', text: 'Fransızca' }
                ]
            };
        },
        computed: {
            displayFileName() {
                if (!this.formData) return '-';
                return this.formData.file_name || this.formData.fileName || this.formData.name || '-';
            },
            tagLabel() {
                if (!this.formData) return '-';
                return this.getLocaleText(this.formData, 'tag_name') || this.formData.tag_name || this.formData.tag_name_en || this.formData.tag || '-';
            }
        },
        created() {
            this.loadTags();
            this.getCV();
        },
        methods: {
            loadTags() {
                ParameterItemService.getItems('cv.tags')
                    .then(res => {
                        const items = res.data?.data || res.data;
                        if (Array.isArray(items) && items.length > 0) {
                            this.tagOptions = items.map(item => ({
                                value: item.code || item.value || item.id,
                                text: item.name || item.title || item.label || item.value
                            }));
                        }
                    })
                    .catch(() => {});
            },
            getCV() {
                CoopCvService.get(this.formId).then(response => {
                    this.formData = response.data.data || response.data;
                });
            },
            downloadFile() {
                CoopCvService.downloadFile(this.formId).then(response => {
                    const blob = new Blob([response.data], { type: response.headers['content-type'] });
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', this.displayFileName !== '-' ? this.displayFileName : `CV_${this.formId}.pdf`);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);
                }).catch(err => {
                    this.showErrors(err);
                });
            }
        }
    };
</script>

<style scoped>
    .label-as-input {
        background-color: #f8f9fa;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
        padding: 0.375rem 0.75rem;
        min-height: 38px;
        display: flex;
        align-items: center;
    }
</style>
